export const es = {
  nav: {
    home: "Inicio",
    services: "Servicios",
    about: "Nosotros",
    contact: "Contacto",
    getInTouch: "Cont\u00e1ctanos",
  },
  hero: {
    overline: "Consultor\u00eda Boutique Premium",
    headline: "Simplificamos lo complejo.",
    subheadline: "Claridad estrat\u00e9gica para marcas, fundadores y negocios listos para avanzar con confianza.",
    cta: "Iniciar una Conversaci\u00f3n",
    secondaryCta: "Explorar Servicios",
  },
  intro: {
    overline: "Qui\u00e9nes Somos",
    title: "Una consultor\u00eda boutique para marcas que se niegan a quedarse estancadas.",
    text: "CREE8 Solutions ayuda a fundadores, marcas y negocios a simplificar la complejidad, mejorar experiencias digitales, afinar su posicionamiento y avanzar con direcci\u00f3n estrat\u00e9gica clara. Convertimos desaf\u00edos abrumadores en caminos claros y accionables.",
  },
  servicesOverview: {
    overline: "Qu\u00e9 Hacemos",
    title: "Tres pilares de claridad estrat\u00e9gica.",
    services: [
      {
        title: "Consultor\u00eda UX",
        description: "Mejores experiencias digitales a trav\u00e9s de pensamiento estrat\u00e9gico UX, usabilidad, claridad y decisiones de producto m\u00e1s inteligentes.",
        icon: "Layers",
      },
      {
        title: "Marketing y Estrategia",
        description: "Posicionamiento m\u00e1s afilado, mensajes m\u00e1s claros y esfuerzos de crecimiento alineados con direcci\u00f3n estrat\u00e9gica inteligente.",
        icon: "Target",
      },
      {
        title: "Mentor\u00eda 1:1",
        description: "Gu\u00eda estrat\u00e9gica personalizada, feedback honesto y apoyo enfocado para fundadores y profesionales que buscan claridad e impulso.",
        icon: "Compass",
      },
    ],
    cta: "Ver Todos los Servicios",
  },
  whyChooseUs: {
    overline: "Por Qu\u00e9 CREE8",
    title: "Diferentes por decisi\u00f3n propia.",
    points: [
      {
        title: "Pensamiento Multidisciplinario",
        description: "Combinamos UX, estrategia y pensamiento creativo para resolver problemas desde todos los \u00e1ngulos.",
        icon: "Layers",
      },
      {
        title: "Enfoque Boutique",
        description: "Cada proyecto recibe atenci\u00f3n dedicada. Sin l\u00edneas de producci\u00f3n, sin delegaciones a juniors.",
        icon: "Diamond",
      },
      {
        title: "Claridad Sobre Complejidad",
        description: "Simplificamos lo que se siente abrumador en direcci\u00f3n estructurada y accionable.",
        icon: "Eye",
      },
      {
        title: "Perspectiva Internacional",
        description: "Biling\u00fces, culturalmente fluidos y con experiencia en mercados e industrias diversas.",
        icon: "Globe",
      },
    ],
  },
  process: {
    overline: "C\u00f3mo Trabajamos",
    title: "De la complejidad a la claridad en cuatro pasos.",
    steps: [
      {
        number: "01",
        title: "Escuchar y Entender",
        description: "Comenzamos entendiendo profundamente tu desaf\u00edo, contexto y objetivos.",
      },
      {
        number: "02",
        title: "Analizar y Simplificar",
        description: "Desglosamos la complejidad en insights claros y estructurados.",
      },
      {
        number: "03",
        title: "Estrategia y Creaci\u00f3n",
        description: "Desarrollamos estrategias enfocadas y soluciones accionables.",
      },
      {
        number: "04",
        title: "Ejecutar y Apoyar",
        description: "Guiamos la implementaci\u00f3n y brindamos soporte estrat\u00e9gico continuo.",
      },
    ],
  },
  trust: {
    overline: "Nuestro Compromiso",
    title: "Tu confianza es nuestra prioridad.",
    guaranteeTitle: "Garant\u00eda de Satisfacci\u00f3n de 30 D\u00edas",
    guaranteeText: "Respaldamos la calidad de nuestro trabajo. Si no est\u00e1s satisfecho con los resultados dentro de los primeros 30 d\u00edas, trabajaremos contigo para resolverlo. Cada proyecto comienza con un contrato claro para que las expectativas, el alcance y el compromiso sean transparentes para ambas partes.",
    points: [
      "Contratos claros antes de cada proyecto",
      "Comunicaci\u00f3n transparente en todo momento",
      "Manejo de satisfacci\u00f3n caso por caso",
      "Resoluci\u00f3n justa si las expectativas no se cumplen",
    ],
  },
  finalCta: {
    title: "\u00bfListo para simplificar?",
    description: "Hablemos sobre tu desaf\u00edo y encontremos un camino claro hacia adelante.",
    cta: "Cont\u00e1ctanos",
  },
  servicesPage: {
    hero: {
      overline: "Nuestros Servicios",
      title: "Claridad estrat\u00e9gica en cada punto de contacto.",
      description: "Ayudamos a marcas, fundadores y negocios a simplificar la complejidad y avanzar con confianza.",
    },
    ux: {
      title: "Consultor\u00eda UX",
      description: "Ayudamos a marcas y negocios a mejorar experiencias digitales a trav\u00e9s de pensamiento estrat\u00e9gico UX, usabilidad, claridad y mejores decisiones de producto.",
      forWhomLabel: "Para qui\u00e9n es",
      forWhom: "Marcas y negocios que quieren que sus productos digitales sean intuitivos, efectivos y alineados con las necesidades del usuario.",
      outcomesLabel: "Resultados Esperados",
      outcomes: [
        "Journeys de usuario m\u00e1s claros y mejores caminos de conversi\u00f3n",
        "Auditor\u00edas UX accionables y recomendaciones estrat\u00e9gicas",
        "Mejores decisiones de producto basadas en investigaci\u00f3n y datos",
        "Interfaces simplificadas que reducen fricci\u00f3n y confusi\u00f3n",
      ],
      cta: "Discutir Tu Desaf\u00edo UX",
    },
    marketing: {
      title: "Marketing y Estrategia",
      description: "Ayudamos a negocios a afinar su posicionamiento, clarificar mensajes y alinear esfuerzos de crecimiento con direcci\u00f3n estrat\u00e9gica m\u00e1s inteligente.",
      forWhomLabel: "Para qui\u00e9n es",
      forWhom: "Negocios que necesitan destacarse, comunicar su valor claramente y crecer con prop\u00f3sito.",
      outcomesLabel: "Resultados Esperados",
      outcomes: [
        "Un posicionamiento de marca claro y diferenciado",
        "Mensajes que resuenan con tu audiencia objetivo",
        "Direcci\u00f3n de marketing estrat\u00e9gica alineada con objetivos de negocio",
        "Esfuerzos de crecimiento m\u00e1s inteligentes enfocados en lo que realmente funciona",
      ],
      cta: "Afinar Tu Estrategia",
    },
    mentoring: {
      title: "Mentor\u00eda 1:1",
      description: "Gu\u00eda estrat\u00e9gica personalizada, feedback honesto y apoyo enfocado para fundadores, creativos y profesionales que buscan claridad e impulso.",
      forWhomLabel: "Para qui\u00e9n es",
      forWhom: "Fundadores, creativos y profesionales que quieren un socio estrat\u00e9gico, no solo consejos.",
      outcomesLabel: "Resultados Esperados",
      outcomes: [
        "Claridad sobre tus pr\u00f3ximos pasos y prioridades estrat\u00e9gicas",
        "Feedback honesto y directo desde una perspectiva experimentada",
        "Pensamiento estructurado para decisiones complejas",
        "Responsabilidad e impulso para avanzar",
      ],
      cta: "Reservar una Sesi\u00f3n",
    },
    guarantee: {
      title: "Nuestra Garant\u00eda de Satisfacci\u00f3n",
      text: "Estamos comprometidos a entregar valor real. Todos los servicios est\u00e1n respaldados por nuestra garant\u00eda de satisfacci\u00f3n de 30 d\u00edas, evaluada caso por caso. Las sesiones de mentor\u00eda pueden reprogramarse con al menos 48 horas de anticipaci\u00f3n.",
    },
  },
  aboutPage: {
    hero: {
      overline: "Nosotros",
      title: "Simplificando la complejidad desde el d\u00eda uno.",
      description: "CREE8 Solutions es una consultor\u00eda boutique premium construida sobre una creencia simple: las mejores soluciones nacen de la claridad, no de la complejidad.",
    },
    story: {
      title: "Nuestra Historia",
      paragraphs: [
        "CREE8 Solutions fue fundada con la convicci\u00f3n de que los negocios no necesitan m\u00e1s ruido \u2014 necesitan m\u00e1s claridad. En un mundo saturado de consejos gen\u00e9ricos y estrategias prefabricadas, elegimos un camino diferente.",
        "Somos una consultor\u00eda liderada por su fundador que combina experiencia multidisciplinaria en UX, estrategia de marketing y mentor\u00eda para ayudar a marcas y negocios a atravesar la complejidad y enfocarse en lo que verdaderamente importa.",
        "Nuestro enfoque es deliberado, estrat\u00e9gico y humano. Nos tomamos el tiempo de entender el contexto \u00fanico de cada cliente antes de ofrecer direcci\u00f3n. Sin plantillas. Sin atajos. Solo trabajo reflexivo y enfocado que genera impulso real.",
      ],
    },
    values: {
      overline: "Lo Que Nos Impulsa",
      title: "Nuestros Valores",
      items: [
        {
          title: "Claridad",
          description: "Creemos que las mejores estrategias son las que se pueden entender claramente y actuar con confianza.",
        },
        {
          title: "Integridad",
          description: "Damos feedback honesto, establecemos expectativas realistas y siempre priorizamos lo que es genuinamente mejor para nuestros clientes.",
        },
        {
          title: "Excelencia",
          description: "Mantenemos nuestro trabajo al m\u00e1s alto est\u00e1ndar. Cada entregable, cada sesi\u00f3n, cada recomendaci\u00f3n refleja nuestro compromiso con la calidad.",
        },
        {
          title: "Alianza",
          description: "Vemos cada relaci\u00f3n con un cliente como una alianza. Tu \u00e9xito es nuestro \u00e9xito.",
        },
      ],
    },
  },
  contactPage: {
    hero: {
      overline: "Contacto",
      title: "Iniciemos una conversaci\u00f3n.",
      description: "\u00bfTienes una propuesta, desaf\u00edo o problema de negocio? Nos encantar\u00eda saber de ti. Escr\u00edbenos y exploremos c\u00f3mo podemos ayudar.",
    },
    form: {
      name: "Nombre Completo",
      namePlaceholder: "Tu nombre completo",
      email: "Correo Electr\u00f3nico",
      emailPlaceholder: "tu@empresa.com",
      company: "Empresa / Marca",
      companyPlaceholder: "Nombre de tu empresa o marca",
      service: "Servicio Necesitado",
      servicePlaceholder: "Selecciona un servicio",
      serviceOptions: [
        "Consultor\u00eda UX",
        "Marketing y Estrategia",
        "Mentor\u00eda 1:1",
        "No estoy seguro a\u00fan",
      ],
      budget: "Rango de Presupuesto",
      budgetPlaceholder: "Selecciona tu presupuesto",
      budgetOptions: [
        "Menos de $2,000",
        "$2,000 \u2013 $5,000",
        "$5,000 \u2013 $10,000",
        "M\u00e1s de $10,000",
      ],
      message: "Tu Mensaje",
      messagePlaceholder: "Cu\u00e9ntanos sobre tu proyecto, desaf\u00edo u objetivos...",
      submit: "Enviar Mensaje",
      sending: "Enviando...",
      successTitle: "Mensaje enviado exitosamente.",
      successText: "Te responderemos dentro de 24\u201348 horas h\u00e1biles.",
      errorText: "Algo sali\u00f3 mal. Por favor intenta de nuevo o escr\u00edbenos directamente.",
    },
    info: {
      title: "Ponte en Contacto",
      emailLabel: "Email",
      email: "hola@cree8solutions.org",
      phoneLabel: "Tel\u00e9fono",
      phone: "+1 (929) 685-2145",
      addressLabel: "Direcci\u00f3n",
      address: ["Suite B, 8 The Green, Dover", "DE 19901", "Estados Unidos"],
    },
  },
  footer: {
    description: "Consultor\u00eda boutique premium ayudando a fundadores, marcas y negocios a simplificar la complejidad y avanzar con claridad estrat\u00e9gica.",
    quickLinks: "Enlaces R\u00e1pidos",
    legal: "Legal",
    connect: "Conectar",
    privacyPolicy: "Pol\u00edtica de Privacidad",
    cookiePolicy: "Pol\u00edtica de Cookies",
    termsConditions: "T\u00e9rminos y Condiciones",
    refundPolicy: "Pol\u00edtica de Reembolso",
    copyright: "\u00a9 2026 Cree8 Solutions LLC. Todos los derechos reservados.",
    address: ["Suite B, 8 The Green, Dover", "DE 19901, Estados Unidos"],
    email: "hola@cree8solutions.org",
    phone: "+1 (929) 685-2145",
  },
  cookieConsent: {
    text: "Utilizamos cookies para mejorar tu experiencia de navegaci\u00f3n y analizar el tr\u00e1fico del sitio.",
    accept: "Aceptar",
    decline: "Rechazar",
    policyLink: "Pol\u00edtica de Cookies",
  },
  privacyPolicy: {
    title: "Pol\u00edtica de Privacidad",
    lastUpdated: "\u00daltima actualizaci\u00f3n: Enero 2025",
    sections: [
      {
        title: "Introducci\u00f3n",
        content: 'Cree8 Solutions LLC ("CREE8 Solutions", "nosotros", "nuestro") est\u00e1 comprometido con la protecci\u00f3n de tu privacidad. Esta Pol\u00edtica de Privacidad explica c\u00f3mo recopilamos, usamos, divulgamos y protegemos tu informaci\u00f3n cuando visitas nuestro sitio web o utilizas nuestros servicios.',
      },
      {
        title: "Informaci\u00f3n que Recopilamos",
        content: "Podemos recopilar informaci\u00f3n personal que proporcionas voluntariamente, incluyendo: tu nombre, direcci\u00f3n de correo electr\u00f3nico, n\u00famero de tel\u00e9fono, nombre de empresa y cualquier otra informaci\u00f3n que elijas compartir a trav\u00e9s de nuestros formularios de contacto o durante la prestaci\u00f3n de servicios. Tambi\u00e9n recopilamos autom\u00e1ticamente cierta informaci\u00f3n t\u00e9cnica como tipo de navegador, direcci\u00f3n IP y comportamiento de navegaci\u00f3n a trav\u00e9s de cookies.",
      },
      {
        title: "C\u00f3mo Usamos Tu Informaci\u00f3n",
        content: "Utilizamos la informaci\u00f3n que recopilamos para: responder a tus consultas y proporcionar nuestros servicios; comunicarnos contigo sobre proyectos, servicios y actualizaciones; mejorar nuestro sitio web y ofertas de servicios; cumplir con obligaciones legales; y proteger nuestros intereses comerciales.",
      },
      {
        title: "Compartir Informaci\u00f3n",
        content: "No vendemos, intercambiamos ni alquilamos tu informaci\u00f3n personal a terceros. Podemos compartir tu informaci\u00f3n con proveedores de servicios de confianza que nos ayudan a operar nuestro negocio, siempre que acepten mantener tu informaci\u00f3n confidencial.",
      },
      {
        title: "Seguridad de Datos",
        content: "Implementamos medidas t\u00e9cnicas y organizativas apropiadas para proteger tu informaci\u00f3n personal. Sin embargo, ning\u00fan m\u00e9todo de transmisi\u00f3n por Internet es 100% seguro y no podemos garantizar seguridad absoluta.",
      },
      {
        title: "Tus Derechos",
        content: "Tienes derecho a: acceder, corregir o eliminar tu informaci\u00f3n personal; optar por no recibir comunicaciones de marketing; solicitar informaci\u00f3n sobre c\u00f3mo se utilizan tus datos. Para ejercer estos derechos, cont\u00e1ctanos en hola@cree8solutions.org.",
      },
      {
        title: "Cont\u00e1ctanos",
        content: "Si tienes preguntas sobre esta Pol\u00edtica de Privacidad, cont\u00e1ctanos en:\n\nCree8 Solutions LLC\nSuite B, 8 The Green, Dover\nDE 19901, Estados Unidos\nEmail: hola@cree8solutions.org\nTel\u00e9fono: +1 (929) 685-2145",
      },
    ],
  },
  cookiePolicyPage: {
    title: "Pol\u00edtica de Cookies",
    lastUpdated: "\u00daltima actualizaci\u00f3n: Enero 2025",
    sections: [
      {
        title: "\u00bfQu\u00e9 Son las Cookies?",
        content: "Las cookies son peque\u00f1os archivos de texto que se almacenan en tu dispositivo cuando visitas un sitio web. Ayudan al sitio web a reconocer tu dispositivo y recordar cierta informaci\u00f3n sobre tu visita.",
      },
      {
        title: "C\u00f3mo Usamos las Cookies",
        content: "Utilizamos cookies para: asegurar que nuestro sitio web funcione correctamente; analizar el tr\u00e1fico y patrones de uso del sitio; recordar tus preferencias y configuraciones; mejorar tu experiencia de navegaci\u00f3n.",
      },
      {
        title: "Tipos de Cookies que Utilizamos",
        content: "Cookies Esenciales: Necesarias para la funcionalidad b\u00e1sica del sitio web. No pueden ser desactivadas.\n\nCookies de An\u00e1lisis: Nos ayudan a entender c\u00f3mo los visitantes interact\u00faan con nuestro sitio web, permiti\u00e9ndonos mejorar nuestro contenido y servicios.\n\nCookies de Preferencias: Recuerdan tus configuraciones y opciones para proporcionar una experiencia m\u00e1s personalizada.",
      },
      {
        title: "Gesti\u00f3n de Cookies",
        content: "Puedes controlar y gestionar las cookies a trav\u00e9s de la configuraci\u00f3n de tu navegador. Ten en cuenta que desactivar ciertas cookies puede afectar la funcionalidad de nuestro sitio web. Tambi\u00e9n puedes usar nuestro banner de consentimiento de cookies para aceptar o rechazar cookies no esenciales.",
      },
      {
        title: "Cont\u00e1ctanos",
        content: "Si tienes preguntas sobre nuestra Pol\u00edtica de Cookies, cont\u00e1ctanos en hola@cree8solutions.org.",
      },
    ],
  },
  termsConditions: {
    title: "T\u00e9rminos y Condiciones",
    lastUpdated: "\u00daltima actualizaci\u00f3n: Enero 2025",
    sections: [
      {
        title: "Aceptaci\u00f3n de T\u00e9rminos",
        content: 'Al acceder o utilizar los servicios proporcionados por Cree8 Solutions LLC ("CREE8 Solutions"), aceptas estar sujeto a estos T\u00e9rminos y Condiciones. Si no est\u00e1s de acuerdo, por favor no utilices nuestros servicios.',
      },
      {
        title: "Servicios",
        content: "CREE8 Solutions proporciona servicios de consultor\u00eda digital incluyendo consultor\u00eda UX, consultor\u00eda de marketing y estrategia, y mentor\u00eda 1:1. El alcance espec\u00edfico, entregables y t\u00e9rminos de cada proyecto se definen en contratos individuales firmados antes de comenzar el trabajo.",
      },
      {
        title: "Contratos y Proyectos",
        content: "Antes de que cualquier proyecto o sesi\u00f3n de mentor\u00eda comience, se firma un contrato para que el compromiso, alcance, expectativas y entregables sean claros para ambas partes. Esto asegura transparencia y entendimiento mutuo durante todo el proyecto.",
      },
      {
        title: "T\u00e9rminos de Pago",
        content: "Los t\u00e9rminos de pago, cronogramas y m\u00e9todos se detallan en los contratos de servicio individuales. Todas las tarifas est\u00e1n en USD a menos que se especifique lo contrario. El pago se espera seg\u00fan el cronograma acordado.",
      },
      {
        title: "Propiedad Intelectual",
        content: "A menos que se indique lo contrario en el contrato de servicio, los entregables creados durante un proyecto se convierten en propiedad del cliente tras el pago completo. CREE8 Solutions se reserva el derecho de usar aspectos no confidenciales del trabajo con fines de portafolio y promoci\u00f3n.",
      },
      {
        title: "Limitaci\u00f3n de Responsabilidad",
        content: "CREE8 Solutions proporciona servicios de consultor\u00eda estrat\u00e9gica y asesor\u00eda. No somos responsables de resultados comerciales, resultados financieros o decisiones de implementaci\u00f3n tomadas por clientes basadas en nuestras recomendaciones. Nuestra responsabilidad se limita a las tarifas pagadas por el servicio espec\u00edfico en cuesti\u00f3n.",
      },
      {
        title: "Ley Aplicable",
        content: "Estos T\u00e9rminos y Condiciones se rigen por las leyes del Estado de Delaware, Estados Unidos. Cualquier disputa se resolver\u00e1 primero a trav\u00e9s de negociaci\u00f3n de buena fe y, si es necesario, a trav\u00e9s de los tribunales apropiados de Delaware.",
      },
      {
        title: "Contacto",
        content: "Para preguntas sobre estos T\u00e9rminos, cont\u00e1ctanos en:\n\nCree8 Solutions LLC\nSuite B, 8 The Green, Dover\nDE 19901, Estados Unidos\nEmail: hola@cree8solutions.org\nTel\u00e9fono: +1 (929) 685-2145",
      },
    ],
  },
  refundPolicy: {
    title: "Pol\u00edtica de Reembolso y Cancelaci\u00f3n",
    lastUpdated: "\u00daltima actualizaci\u00f3n: Enero 2025",
    sections: [
      {
        title: "Descripci\u00f3n General",
        content: "En CREE8 Solutions, la satisfacci\u00f3n del cliente es nuestra prioridad. Debido a que proporcionamos servicios digitales y proyectos de consultor\u00eda, cada situaci\u00f3n se maneja caso por caso con justicia y transparencia.",
      },
      {
        title: "Garant\u00eda de Satisfacci\u00f3n de 30 D\u00edas",
        content: "Ofrecemos una garant\u00eda de satisfacci\u00f3n de 30 d\u00edas en nuestros servicios de consultor\u00eda. Si no est\u00e1s satisfecho con la calidad de nuestro trabajo dentro de los primeros 30 d\u00edas, cont\u00e1ctanos y trabajaremos juntos para encontrar una resoluci\u00f3n justa. Esto puede incluir revisiones, soporte adicional o un reembolso parcial dependiendo de las circunstancias.",
      },
      {
        title: "Sesiones de Mentor\u00eda",
        content: "Las sesiones de mentor\u00eda pueden reprogramarse con al menos 48 horas de anticipaci\u00f3n sin costo adicional. Si se da menos de 48 horas de aviso, la tarifa completa de la sesi\u00f3n puede seguir aplicando. Las ausencias se consideran sesiones utilizadas.",
      },
      {
        title: "Cancelaciones de Proyectos",
        content: "Si necesitas cancelar un proyecto en curso, notif\u00edcanos lo antes posible. Las tarifas por trabajo ya completado no son reembolsables. Cualquier porci\u00f3n no utilizada de tarifas prepagadas puede ser reembolsada a nuestra discreci\u00f3n, dependiendo de la etapa del proyecto.",
      },
      {
        title: "Contratos y Claridad",
        content: "Antes de que cualquier proyecto o sesi\u00f3n de mentor\u00eda comience, se firma un contrato para que el compromiso, alcance y expectativas sean claros para ambas partes. Esto ayuda a prevenir malentendidos y asegura que ambas partes est\u00e9n alineadas desde el inicio.",
      },
      {
        title: "C\u00f3mo Solicitar un Reembolso",
        content: "Para solicitar un reembolso o discutir cualquier inquietud sobre tu servicio, cont\u00e1ctanos en:\n\nEmail: hola@cree8solutions.org\nTel\u00e9fono: +1 (929) 685-2145\n\nRevisaremos tu solicitud y responderemos dentro de 5 d\u00edas h\u00e1biles.",
      },
    ],
  },
};
